import {
  initialState,
  Actions,
  State,
  DELETE_RESPONSIBLE,
  DELETE_RESPONSIBLE_SUCCESS,
  DELETE_RESPONSIBLE_ERROR,
  RESET_DELETE_RESPONSIBLE,
} from '../../types/responsible/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_RESPONSIBLE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_RESPONSIBLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_RESPONSIBLE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_RESPONSIBLE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
